import { render, staticRenderFns } from "./reviewSteps.vue?vue&type=template&id=b8226f7a&scoped=true&"
import script from "./reviewSteps.vue?vue&type=script&lang=js&"
export * from "./reviewSteps.vue?vue&type=script&lang=js&"
import style0 from "./reviewSteps.vue?vue&type=style&index=0&id=b8226f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8226f7a",
  null
  
)

export default component.exports